import React from 'react';
import './TableScrollContainer.css';

function TableScrollContainer({
  rows = 0,
  threshold = 15,
  maxHeight = 'min(68vh, 720px)',
  children,
  className = '',
}) {
  const shouldScroll = Number(rows || 0) > threshold;

  return (
    <div
      className={`table-scroll-container ${shouldScroll ? 'with-vertical-scroll' : ''} ${className}`.trim()}
      style={{ '--table-max-height': maxHeight }}
    >
      {children}
    </div>
  );
}

export default TableScrollContainer;
